import { AscDerivedParameterDetailsContainer } from './containers'

import Index from './Index'
import { role } from '@/utilities/userRoles'
import { permission } from '@/utilities/userPermissions'

const DerivedParametersRouter = {
  path: '/user',
  component: Index,
  meta: {},
  children: [
    {
      path: '/custom-parameters/:alertType/:parameterID?',
      name: 'My Custom Parameter',
      component: AscDerivedParameterDetailsContainer,
      meta: {
        requiresRole: [role.airlineUser],
        requiresPermission: [permission.derivedParametersFullFlight],
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Custom Parameters',
            to: '/custom-parameters',
          },
          {
            text: route =>
              `${
                route.params.alertType === 'fullFlight'
                  ? 'Set New Custom Parameter'
                  : 'NA'
              }`,
          },
        ],
      },
      props: route => ({
        alertType: route.params.alertType,
        airlineId: route.params.airlineId,
        isSingleAirlineUser: route.params.isSingleAirlineUser,
        parameterID: isNaN(route.params.parameterID)
          ? 0
          : Number(route.params.parameterID),
        masterModelId: route.params.platformId,
      }),
      children: [],
    },
  ],
}
export default DerivedParametersRouter
